import { render, staticRenderFns } from "./Luck2DrawRecord.vue?vue&type=template&id=5e729292&scoped=true&"
import script from "./Luck2DrawRecord.vue?vue&type=script&lang=js&"
export * from "./Luck2DrawRecord.vue?vue&type=script&lang=js&"
import style0 from "./Luck2DrawRecord.vue?vue&type=style&index=0&id=5e729292&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e729292",
  null
  
)

export default component.exports